// extracted by mini-css-extract-plugin
export default {"sections":"yPXpH2","section":"H_6KDA","content":"U0KagT","contentBorderless":"AqmN8E","title":"Om_mqB","subtitle":"jLWvrd","optionButtons":"VAwh15"};